import { TeamContext } from "@/components/context-providers/TeamProvider";
import { TeamCreationType } from "@/gen_src/proto/chalk/server/v1/team_pb";
import { useSession } from "next-auth/react";
import { useContext } from "react";

export const usePylonEnabled = (): boolean => {
  const context = useContext(TeamContext);
  const session = useSession().data;
  // A cached team from another session must not enable support while switching teams.
  return (
    context?.team != null &&
    !context.teamLoading &&
    context.teamError == null &&
    context.team.id === session?.teamId &&
    // UNSPECIFIED also represents managed teams created before this field existed.
    (context.team.teamCreationType === TeamCreationType.CHALK_MANAGED ||
      context.team.teamCreationType === TeamCreationType.UNSPECIFIED)
  );
};
